import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black pb-6" }, " Property when contacts should move to the next action ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "pt-8 text-gray-800" }, "Perform this action", -1)

import { watch } from "vue"

import GgmsDropdown from "@/components/GgmsDropdown.vue"
import GgmsRadioSelect from "@/components/GgmsRadioSelect.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { ClockIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePropertyComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

const options = ["Last activity date"]
const radioButtonsOptions = [
    { displayName: "On date", value: "at" },
    { displayName: "After date", value: "after" },
    { displayName: "Before date", value: "before" },
]

watch(
    () => workflowStore.modelValue?.date,
    () => {
        if (workflowStore.modelValue?.date && workflowStore.modelValue?.time && workflowStore.modelValue?.event) {
            workflowStore.areButtonDisabled = false
        }
    }
)
watch(
    () => workflowStore.modelValue?.time,
    () => {
        if (workflowStore.modelValue?.date && workflowStore.modelValue?.time && workflowStore.modelValue?.event) {
            workflowStore.areButtonDisabled = false
        }
    }
)

watch(
    () => workflowStore.modelValue?.event,
    () => {
        if (workflowStore.modelValue?.date && workflowStore.modelValue?.time && workflowStore.modelValue?.event) {
            workflowStore.areButtonDisabled = false
        }
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GgmsDropdown, {
      modelValue: _unref(workflowStore).modelValue.date,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.date) = $event)),
      class: "w-full",
      options: options,
      placeholder: "Select property"
    }, null, 8, ["modelValue"]),
    _hoisted_3,
    _createVNode(GgmsRadioSelect, {
      modelValue: _unref(workflowStore).modelValue.event,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event)),
      options: radioButtonsOptions,
      buttonsInline: true
    }, null, 8, ["modelValue"]),
    _createVNode(GgmsInput, {
      modelValue: _unref(workflowStore).modelValue.time,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(workflowStore).modelValue.time) = $event)),
      class: "pt-8",
      label: "Time of day",
      type: "time",
      iconStart: _unref(ClockIcon)
    }, null, 8, ["modelValue", "iconStart"])
  ]))
}
}

})